"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ActivityLevel", {
  enumerable: true,
  get: function get() {
    return _ActivityLevel.default;
  }
});
Object.defineProperty(exports, "ActivityLevelApi", {
  enumerable: true,
  get: function get() {
    return _ActivityLevelApi.default;
  }
});
Object.defineProperty(exports, "ActivityLevelPct", {
  enumerable: true,
  get: function get() {
    return _ActivityLevelPct.default;
  }
});
Object.defineProperty(exports, "ActivityLevelsResponse", {
  enumerable: true,
  get: function get() {
    return _ActivityLevelsResponse.default;
  }
});
Object.defineProperty(exports, "ActivityLevelsSummaryResponse", {
  enumerable: true,
  get: function get() {
    return _ActivityLevelsSummaryResponse.default;
  }
});
Object.defineProperty(exports, "ApiClient", {
  enumerable: true,
  get: function get() {
    return _ApiClient.default;
  }
});
Object.defineProperty(exports, "AuthCodeApi", {
  enumerable: true,
  get: function get() {
    return _AuthCodeApi.default;
  }
});
Object.defineProperty(exports, "AuthCodeResponse", {
  enumerable: true,
  get: function get() {
    return _AuthCodeResponse.default;
  }
});
Object.defineProperty(exports, "AuthCodeUpdateRequest", {
  enumerable: true,
  get: function get() {
    return _AuthCodeUpdateRequest.default;
  }
});
Object.defineProperty(exports, "BeaconApi", {
  enumerable: true,
  get: function get() {
    return _BeaconApi.default;
  }
});
Object.defineProperty(exports, "BeaconCheckInApi", {
  enumerable: true,
  get: function get() {
    return _BeaconCheckInApi.default;
  }
});
Object.defineProperty(exports, "BeaconCreate", {
  enumerable: true,
  get: function get() {
    return _BeaconCreate.default;
  }
});
Object.defineProperty(exports, "BeaconCreateRequest", {
  enumerable: true,
  get: function get() {
    return _BeaconCreateRequest.default;
  }
});
Object.defineProperty(exports, "BeaconResponse", {
  enumerable: true,
  get: function get() {
    return _BeaconResponse.default;
  }
});
Object.defineProperty(exports, "BeaconUpdate", {
  enumerable: true,
  get: function get() {
    return _BeaconUpdate.default;
  }
});
Object.defineProperty(exports, "BeaconUpdateRequest", {
  enumerable: true,
  get: function get() {
    return _BeaconUpdateRequest.default;
  }
});
Object.defineProperty(exports, "CaloriesApi", {
  enumerable: true,
  get: function get() {
    return _CaloriesApi.default;
  }
});
Object.defineProperty(exports, "CheckIn", {
  enumerable: true,
  get: function get() {
    return _CheckIn.default;
  }
});
Object.defineProperty(exports, "CheckInSummaryResponse", {
  enumerable: true,
  get: function get() {
    return _CheckInSummaryResponse.default;
  }
});
Object.defineProperty(exports, "CheckInsResponse", {
  enumerable: true,
  get: function get() {
    return _CheckInsResponse.default;
  }
});
Object.defineProperty(exports, "Client", {
  enumerable: true,
  get: function get() {
    return _Client.default;
  }
});
Object.defineProperty(exports, "DeviceApi", {
  enumerable: true,
  get: function get() {
    return _DeviceApi.default;
  }
});
Object.defineProperty(exports, "DevicesReponse", {
  enumerable: true,
  get: function get() {
    return _DevicesReponse.default;
  }
});
Object.defineProperty(exports, "EmailCheckResponse", {
  enumerable: true,
  get: function get() {
    return _EmailCheckResponse.default;
  }
});
Object.defineProperty(exports, "FirmwareUpdatesReponse", {
  enumerable: true,
  get: function get() {
    return _FirmwareUpdatesReponse.default;
  }
});
Object.defineProperty(exports, "FirmwareVersionApi", {
  enumerable: true,
  get: function get() {
    return _FirmwareVersionApi.default;
  }
});
Object.defineProperty(exports, "Goal", {
  enumerable: true,
  get: function get() {
    return _Goal.default;
  }
});
Object.defineProperty(exports, "Goals", {
  enumerable: true,
  get: function get() {
    return _Goals.default;
  }
});
Object.defineProperty(exports, "GoalsApi", {
  enumerable: true,
  get: function get() {
    return _GoalsApi.default;
  }
});
Object.defineProperty(exports, "GoalsResponse", {
  enumerable: true,
  get: function get() {
    return _GoalsResponse.default;
  }
});
Object.defineProperty(exports, "Helix", {
  enumerable: true,
  get: function get() {
    return _Helix.default;
  }
});
Object.defineProperty(exports, "HelixApi", {
  enumerable: true,
  get: function get() {
    return _HelixApi.default;
  }
});
Object.defineProperty(exports, "HelixCreateBody", {
  enumerable: true,
  get: function get() {
    return _HelixCreateBody.default;
  }
});
Object.defineProperty(exports, "HelixCreateRequest", {
  enumerable: true,
  get: function get() {
    return _HelixCreateRequest.default;
  }
});
Object.defineProperty(exports, "HelixResponse", {
  enumerable: true,
  get: function get() {
    return _HelixResponse.default;
  }
});
Object.defineProperty(exports, "HelixUpdatePetIdBody", {
  enumerable: true,
  get: function get() {
    return _HelixUpdatePetIdBody.default;
  }
});
Object.defineProperty(exports, "HelixUpdatePetIdRequest", {
  enumerable: true,
  get: function get() {
    return _HelixUpdatePetIdRequest.default;
  }
});
Object.defineProperty(exports, "HelixUpdateRequest", {
  enumerable: true,
  get: function get() {
    return _HelixUpdateRequest.default;
  }
});
Object.defineProperty(exports, "Hub", {
  enumerable: true,
  get: function get() {
    return _Hub.default;
  }
});
Object.defineProperty(exports, "HubApi", {
  enumerable: true,
  get: function get() {
    return _HubApi.default;
  }
});
Object.defineProperty(exports, "HubResponse", {
  enumerable: true,
  get: function get() {
    return _HubResponse.default;
  }
});
Object.defineProperty(exports, "HubUpdateBody", {
  enumerable: true,
  get: function get() {
    return _HubUpdateBody.default;
  }
});
Object.defineProperty(exports, "HubUpdateRequest", {
  enumerable: true,
  get: function get() {
    return _HubUpdateRequest.default;
  }
});
Object.defineProperty(exports, "ImageSet", {
  enumerable: true,
  get: function get() {
    return _ImageSet.default;
  }
});
Object.defineProperty(exports, "PasswordGrantRequest", {
  enumerable: true,
  get: function get() {
    return _PasswordGrantRequest.default;
  }
});
Object.defineProperty(exports, "PasswordRequest", {
  enumerable: true,
  get: function get() {
    return _PasswordRequest.default;
  }
});
Object.defineProperty(exports, "PasswordResetApi", {
  enumerable: true,
  get: function get() {
    return _PasswordResetApi.default;
  }
});
Object.defineProperty(exports, "Pet", {
  enumerable: true,
  get: function get() {
    return _Pet.default;
  }
});
Object.defineProperty(exports, "PetApi", {
  enumerable: true,
  get: function get() {
    return _PetApi.default;
  }
});
Object.defineProperty(exports, "PetCutpointsApi", {
  enumerable: true,
  get: function get() {
    return _PetCutpointsApi.default;
  }
});
Object.defineProperty(exports, "PetRequest", {
  enumerable: true,
  get: function get() {
    return _PetRequest.default;
  }
});
Object.defineProperty(exports, "PetRequestBody", {
  enumerable: true,
  get: function get() {
    return _PetRequestBody.default;
  }
});
Object.defineProperty(exports, "PetResponse", {
  enumerable: true,
  get: function get() {
    return _PetResponse.default;
  }
});
Object.defineProperty(exports, "PetsResponseOuter", {
  enumerable: true,
  get: function get() {
    return _PetsResponseOuter.default;
  }
});
Object.defineProperty(exports, "RawDataApi", {
  enumerable: true,
  get: function get() {
    return _RawDataApi.default;
  }
});
Object.defineProperty(exports, "RefreshGrantRequest", {
  enumerable: true,
  get: function get() {
    return _RefreshGrantRequest.default;
  }
});
Object.defineProperty(exports, "RefreshGrantRequestAllOf", {
  enumerable: true,
  get: function get() {
    return _RefreshGrantRequestAllOf.default;
  }
});
Object.defineProperty(exports, "RequirementResponse", {
  enumerable: true,
  get: function get() {
    return _RequirementResponse.default;
  }
});
Object.defineProperty(exports, "Requirements", {
  enumerable: true,
  get: function get() {
    return _Requirements.default;
  }
});
Object.defineProperty(exports, "RequirementsResponse", {
  enumerable: true,
  get: function get() {
    return _RequirementsResponse.default;
  }
});
Object.defineProperty(exports, "StandardError", {
  enumerable: true,
  get: function get() {
    return _StandardError.default;
  }
});
Object.defineProperty(exports, "SummaryDataApi", {
  enumerable: true,
  get: function get() {
    return _SummaryDataApi.default;
  }
});
Object.defineProperty(exports, "TokenApi", {
  enumerable: true,
  get: function get() {
    return _TokenApi.default;
  }
});
Object.defineProperty(exports, "TokenResponse", {
  enumerable: true,
  get: function get() {
    return _TokenResponse.default;
  }
});
Object.defineProperty(exports, "TokensApi", {
  enumerable: true,
  get: function get() {
    return _TokensApi.default;
  }
});
Object.defineProperty(exports, "TokensRequest", {
  enumerable: true,
  get: function get() {
    return _TokensRequest.default;
  }
});
Object.defineProperty(exports, "TokensResponse", {
  enumerable: true,
  get: function get() {
    return _TokensResponse.default;
  }
});
Object.defineProperty(exports, "UploadCutpointsRequest", {
  enumerable: true,
  get: function get() {
    return _UploadCutpointsRequest.default;
  }
});
Object.defineProperty(exports, "UploadSummaryDataRequest", {
  enumerable: true,
  get: function get() {
    return _UploadSummaryDataRequest.default;
  }
});
Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function get() {
    return _User.default;
  }
});
Object.defineProperty(exports, "UserApi", {
  enumerable: true,
  get: function get() {
    return _UserApi.default;
  }
});
Object.defineProperty(exports, "UserRequest", {
  enumerable: true,
  get: function get() {
    return _UserRequest.default;
  }
});
Object.defineProperty(exports, "UserResponse", {
  enumerable: true,
  get: function get() {
    return _UserResponse.default;
  }
});
Object.defineProperty(exports, "VersionRequirementApi", {
  enumerable: true,
  get: function get() {
    return _VersionRequirementApi.default;
  }
});

var _ApiClient = _interopRequireDefault(require("./ApiClient"));

var _ActivityLevel = _interopRequireDefault(require("./model/ActivityLevel"));

var _ActivityLevelPct = _interopRequireDefault(require("./model/ActivityLevelPct"));

var _ActivityLevelsResponse = _interopRequireDefault(require("./model/ActivityLevelsResponse"));

var _ActivityLevelsSummaryResponse = _interopRequireDefault(require("./model/ActivityLevelsSummaryResponse"));

var _AuthCodeResponse = _interopRequireDefault(require("./model/AuthCodeResponse"));

var _AuthCodeUpdateRequest = _interopRequireDefault(require("./model/AuthCodeUpdateRequest"));

var _BeaconCreate = _interopRequireDefault(require("./model/BeaconCreate"));

var _BeaconCreateRequest = _interopRequireDefault(require("./model/BeaconCreateRequest"));

var _BeaconResponse = _interopRequireDefault(require("./model/BeaconResponse"));

var _BeaconUpdate = _interopRequireDefault(require("./model/BeaconUpdate"));

var _BeaconUpdateRequest = _interopRequireDefault(require("./model/BeaconUpdateRequest"));

var _CheckIn = _interopRequireDefault(require("./model/CheckIn"));

var _CheckInSummaryResponse = _interopRequireDefault(require("./model/CheckInSummaryResponse"));

var _CheckInsResponse = _interopRequireDefault(require("./model/CheckInsResponse"));

var _Client = _interopRequireDefault(require("./model/Client"));

var _DevicesReponse = _interopRequireDefault(require("./model/DevicesReponse"));

var _EmailCheckResponse = _interopRequireDefault(require("./model/EmailCheckResponse"));

var _FirmwareUpdatesReponse = _interopRequireDefault(require("./model/FirmwareUpdatesReponse"));

var _Goal = _interopRequireDefault(require("./model/Goal"));

var _Goals = _interopRequireDefault(require("./model/Goals"));

var _GoalsResponse = _interopRequireDefault(require("./model/GoalsResponse"));

var _Helix = _interopRequireDefault(require("./model/Helix"));

var _HelixCreateBody = _interopRequireDefault(require("./model/HelixCreateBody"));

var _HelixCreateRequest = _interopRequireDefault(require("./model/HelixCreateRequest"));

var _HelixResponse = _interopRequireDefault(require("./model/HelixResponse"));

var _HelixUpdatePetIdBody = _interopRequireDefault(require("./model/HelixUpdatePetIdBody"));

var _HelixUpdatePetIdRequest = _interopRequireDefault(require("./model/HelixUpdatePetIdRequest"));

var _HelixUpdateRequest = _interopRequireDefault(require("./model/HelixUpdateRequest"));

var _Hub = _interopRequireDefault(require("./model/Hub"));

var _HubResponse = _interopRequireDefault(require("./model/HubResponse"));

var _HubUpdateBody = _interopRequireDefault(require("./model/HubUpdateBody"));

var _HubUpdateRequest = _interopRequireDefault(require("./model/HubUpdateRequest"));

var _ImageSet = _interopRequireDefault(require("./model/ImageSet"));

var _PasswordGrantRequest = _interopRequireDefault(require("./model/PasswordGrantRequest"));

var _PasswordRequest = _interopRequireDefault(require("./model/PasswordRequest"));

var _Pet = _interopRequireDefault(require("./model/Pet"));

var _PetRequest = _interopRequireDefault(require("./model/PetRequest"));

var _PetRequestBody = _interopRequireDefault(require("./model/PetRequestBody"));

var _PetResponse = _interopRequireDefault(require("./model/PetResponse"));

var _PetsResponseOuter = _interopRequireDefault(require("./model/PetsResponseOuter"));

var _RefreshGrantRequest = _interopRequireDefault(require("./model/RefreshGrantRequest"));

var _RefreshGrantRequestAllOf = _interopRequireDefault(require("./model/RefreshGrantRequestAllOf"));

var _RequirementResponse = _interopRequireDefault(require("./model/RequirementResponse"));

var _Requirements = _interopRequireDefault(require("./model/Requirements"));

var _RequirementsResponse = _interopRequireDefault(require("./model/RequirementsResponse"));

var _StandardError = _interopRequireDefault(require("./model/StandardError"));

var _TokenResponse = _interopRequireDefault(require("./model/TokenResponse"));

var _TokensRequest = _interopRequireDefault(require("./model/TokensRequest"));

var _TokensResponse = _interopRequireDefault(require("./model/TokensResponse"));

var _UploadCutpointsRequest = _interopRequireDefault(require("./model/UploadCutpointsRequest"));

var _UploadSummaryDataRequest = _interopRequireDefault(require("./model/UploadSummaryDataRequest"));

var _User = _interopRequireDefault(require("./model/User"));

var _UserRequest = _interopRequireDefault(require("./model/UserRequest"));

var _UserResponse = _interopRequireDefault(require("./model/UserResponse"));

var _ActivityLevelApi = _interopRequireDefault(require("./api/ActivityLevelApi"));

var _AuthCodeApi = _interopRequireDefault(require("./api/AuthCodeApi"));

var _BeaconApi = _interopRequireDefault(require("./api/BeaconApi"));

var _BeaconCheckInApi = _interopRequireDefault(require("./api/BeaconCheckInApi"));

var _CaloriesApi = _interopRequireDefault(require("./api/CaloriesApi"));

var _DeviceApi = _interopRequireDefault(require("./api/DeviceApi"));

var _FirmwareVersionApi = _interopRequireDefault(require("./api/FirmwareVersionApi"));

var _GoalsApi = _interopRequireDefault(require("./api/GoalsApi"));

var _HelixApi = _interopRequireDefault(require("./api/HelixApi"));

var _HubApi = _interopRequireDefault(require("./api/HubApi"));

var _PasswordResetApi = _interopRequireDefault(require("./api/PasswordResetApi"));

var _PetApi = _interopRequireDefault(require("./api/PetApi"));

var _PetCutpointsApi = _interopRequireDefault(require("./api/PetCutpointsApi"));

var _RawDataApi = _interopRequireDefault(require("./api/RawDataApi"));

var _SummaryDataApi = _interopRequireDefault(require("./api/SummaryDataApi"));

var _TokenApi = _interopRequireDefault(require("./api/TokenApi"));

var _TokensApi = _interopRequireDefault(require("./api/TokensApi"));

var _UserApi = _interopRequireDefault(require("./api/UserApi"));

var _VersionRequirementApi = _interopRequireDefault(require("./api/VersionRequirementApi"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }